<template>
  <div class="weui-tab feedback-tab">
    <div class="weui-tab__panel">
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </div>
    <div class="weui-tabbar">
      <a href="javascript:;" class="weui-tabbar__item" :class="{ 'weui-bar__item_on': activeTab == 'home' }"
        @click="setActive('home', '')">
        <span class="weui-tabbar__icon iconfont icon-home" />
        <p class="weui-tabbar__label">全部</p>
      </a>
      <router-link href="javascript:;" class="weui-tabbar__item" to="/help/feedback_edit">
        <span class="weui-tabbar__icon iconfont icon-add" />
        <p class="weui-tabbar__label">说两句</p>
      </router-link>
      <a href="javascript:;" class="weui-tabbar__item" :class="{ 'weui-bar__item_on': activeTab == 'mine' }"
        @click="setActive('mine', '/mine')">
        <span class="weui-tabbar__icon iconfont icon-user" />
        <p class="weui-tabbar__label">我的</p>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeTab: "home"
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.activeTab = to.meta.activeTab;
    });
  },
  watch: {
    $route: function (to) {
      this.activeTab = to.meta.activeTab;
    }
  },
  methods: {
    setActive(name, path) {
      var me = this;
      me.activeTab = name;
      me.$router.push("/help/feedback" + path);
    }
  }
};
</script>

<style>
.feedback-tab {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
</style>
